import { render } from "./img.graceful.vue?vue&type=template&id=588ebd63"
import script from "./img.graceful.vue?vue&type=script&lang=js"
export * from "./img.graceful.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__